import EquipSplashScreen from "@/ui/components/splashScreen/EquipSplashScreen";
import { isWeb } from "@/utils/platform.util";

// transitionMs set to 0 to prevent fade-in animations on successive SplashScreens
const TransitionMs = isWeb() ? 0 : undefined;

// by default, expo-router resolves an empty / ambiguity in (app) by failing through the alphabetical-first leaf,
// which is (app)/(modals)/assessment-task.tsx, which thus briefly appears in the browser URL when refreshing.
// so instead, placing the same SplashScreen as elsewhere here as a placeholder; actual navigation handled by postLoginRouting
const Index = () => <EquipSplashScreen transitionMs={TransitionMs} />;

// eslint-disable-next-line import-x/no-unused-modules -- used by expo-router file based navigation but TypeScript can not infer its usage
export default Index;
